/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unknown-property */
import React from 'react';
import s from './WeatherAqiReports.scss';
import Link from '../../../components/Link/Link';

const WeatherAqiReports = ({ value, status, aqiLink, cityName, cityId }) => {
  const aqiPercentage = (value || 0) / 500 * 100;

  return (
    <Link
      to={aqiLink}
      className={`${s.weatherAqiReports} boxWrap`}
      ga4Data={[
        {
          event: 'user_click',
          type: 'aqi_widget',
          category: 'aqi_widget_click',
          label: `${cityName}_${cityId}`,
          msid: `${cityId}`,
        },
      ]}
    >
      <div className="fs12 hFont mb12 flex flexAc">
        <i className="icon mr6 airAuality" /> Air Quality{' '}
        <i className="icon ml8 rightArrow" />
      </div>

      <div className="fs18 bold mtb12">
        {value} {status ? `- ${status}` : ''}
      </div>
      <div className={s.pollutionBar}>
        <i
          className={s.ringIcon}
          style={{ left: aqiPercentage > 100 ? 100 : aqiPercentage }}
        />
      </div>
    </Link>
  );
};

export default WeatherAqiReports;
